import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export const SimpleCheckbox = (props: CheckboxProps) => (
  <Checkbox
    {...props}
    icon={<CheckBoxOutlineBlankIcon data-testid="CheckBoxOutlineBlankIcon" />}
    checkedIcon={<CheckBoxIcon data-testid="CheckBoxIcon" />}
  />
);
